module.exports = __webpack_public_path__ + "static/media/mercury.a92f7a38.svg";